import React, { useState } from 'react';
import { getDatabase, ref, get, set, child, get as getData } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { app } from './firebase'; // Adjust the import based on your project structure

import loadingspinner from '../assets/images/loading2.gif'


const UpdateStudentPhotos = () => {
  const [message, setMessage] = useState('');
    const [savingData, setSavingData] = useState(false); 

  const handleMoveImages = async () => {
    const db = getDatabase(app);
    const storage = getStorage(app);
    const studentsRef = ref(db, `schoolRegister/1/studentData`); 
    setSavingData(true);

    try {
      const snapshot = await getData(studentsRef);
      if (snapshot.exists()) {
        const studentsData = snapshot.val();
        const studentKeys = Object.keys(studentsData);
        let successCount = 0;

        for (const key of studentKeys) {
          const studentData = studentsData[key];
          const { stdPhoto } = studentData;

          // Check if stdPhoto is a base64 image
          if (stdPhoto && stdPhoto.startsWith('data:image/')) {
            // Convert base64 to Blob
            const response = await fetch(stdPhoto);
            const blob = await response.blob();

            // Create a storage reference
            const photoRef = storageRef(storage, `1/student${key}`); // Adjust the file extension as needed

            // Upload the Blob to Firebase Storage
            await uploadBytes(photoRef, blob);

            // Get the download URL
            const downloadURL = await getDownloadURL(photoRef);

            // Update the stdPhoto field in the Realtime Database
            await set(ref(db, `schoolRegister/1/studentData/${key}`), { ...studentData, stdPhoto: downloadURL });
            successCount++;
          }
        }
        setSavingData(false);

        setMessage(`${successCount} photos moved to storage successfully!`);
      } else {
        setMessage('No students found.');
        setSavingData(false);

      }
    } catch (error) {
      console.error('Error moving student photos:', error);
      setMessage('An error occurred while moving the photos.');
    }
  };

  return (
    <div className='main-content-of-page'>
      {savingData && <img width={'40px'} className="registerLoading" src={loadingspinner} />}
      <h2>Move Base64 Images to Storage</h2>
      <button onClick={handleMoveImages}>Move Images</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default UpdateStudentPhotos;